import { Button, Modal, Rate } from 'antd';
import styled from 'styled-components';
import SVGIcon from '../SVGIcon/SVGIcon';

export const CheckIcon = styled(SVGIcon)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const CheckIconMobile = styled(SVGIcon)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const StyledModal = styled(Modal)`
  width: 720px !important;
  height: 484px;

  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
    padding: 0;
  }

  .ant-modal-body {
    padding: 0;
    height: 100%;
  }

  .ant-modal-close {
    color: #000;
    top: 20px;
    right: 20px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px 20px;
  text-align: center;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: #343538;
`;

export const OrderNoteIdWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const OrderFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const OrderFlexInfo = styled(OrderFlex)`
  margin: 12px 0;
`;

export const OrderNote = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #343538;
  line-height: 24px;
`;

export const OrderId = styled(OrderNote)`
  color: #388bff;
`;

export const OrderInfoText = styled.p<{ width?: number }>`
  font-size: ${({ width }) => (width > 576 ? '14px' : '12px')};
  font-weight: 400;
  color: #585a60;
  line-height: ${({ width }) => (width > 576 ? '20px' : '16px')};
`;

export const StyledRate = styled(Rate)<{ rating: number }>`
  font-size: 36px;
  margin: ${({ rating }) => (rating === 0 ? '20px 0 24px' : '20px 0 0')};

  .ant-rate-star {
  }

  .ant-rate-star-full .ant-rate-star-second,
  .ant-rate-star-full .ant-rate-star-first {
    color: #f5ce47;
    text-stroke: 1px #e3b205;
    -webkit-text-stroke: 1px #e3b205;
  }

  .ant-rate-star-zero .ant-rate-star-first,
  .ant-rate-star-zero .ant-rate-star-second {
    color: #fff7d6;
    text-stroke: 1px #f8e6a0;
    -webkit-text-stroke: 1px #f8e6a0;
  }
`;

export const FeedbackText = styled(OrderInfoText)`
  max-width: 480px;
  margin-bottom: 24px;
`;

export const LaterButton = styled(Button)`
  width: 160px;
  min-width: 90px;
  padding: 8px 12px;
  font-weight: 500;
`;

export const SubmitButton = styled(LaterButton)`
  background-color: #43a047;
  color: #fff;

  &:hover,
  &:focus,
  &:active {
    background-color: #43a047 !important;
    color: #fff !important;
  }
`;

export const FeedbackSymbol = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  position: relative;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? '#43a047' : '#cacbce')};
  flex: 1;
  height: 100px;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#F0F9F1' : 'transparent')};
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    border-color: #43a047;
  }
`;

export const FeedbackSymbolMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
`;

export const FeedbackSymbolMobile = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  position: relative;
  gap: 8px;
  border-radius: 50%;
  border: 1px solid ${({ selected }) => (selected ? '#43a047' : '#cacbce')};
  flex: 1;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#F0F9F1' : 'transparent')};
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    border-color: #43a047;
  }
`;

export const FeedbackWrapper = styled(OrderNoteIdWrapper)`
  width: 100%;
  gap: 16px;
  margin: 24px 0;
`;

export const NoteFeedBackWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 24px;
`;

export const NoteLabel = styled.label`
  color: #242527;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
